 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		53: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		53: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"20":"affiliate-page","21":"algolia-search","22":"algolia-search-local","23":"card-error","24":"cart-drawer","25":"christmas-holiday-gift-cards-page","26":"consumer-checkout-page","27":"consumer-checkout-page-footer-content","28":"create-a-card-carrier","29":"create-a-card-landing","30":"create-a-card-review","31":"designer-gift-cards","32":"diwali-holiday-gift-cards-page","33":"gift-card-app-page","34":"gift-card-balance-check-page","35":"gift-card-occasions","36":"greeting-card-landing-page","37":"handwritten-page","38":"hanukkah-holiday-gift-cards-page","39":"home-page","40":"kwanzaa-holiday-gift-cards-page","41":"legit-page","43":"mastercard-pla-landing-page","44":"newsletter-signup-page","45":"open-loop-activate-check-balance","46":"open-loop-virtual-exchange","47":"order-details","48":"order-status","49":"pla-landing-page-container","50":"redeem-gift","51":"redeem-gyp-gift","52":"reviews-page","54":"smb-apply","55":"smb-cobrand-cards","56":"smb-order-details","57":"smb-order-details-pdf-invoice","58":"smb-order-flow","59":"smb-order-flow-cancelled","60":"smb-order-flow-confirmation","61":"smb-order-flow-customize-product","62":"smb-order-flow-footer-content","63":"smb-order-flow-landing","64":"smb-order-flow-login","65":"smb-order-flow-merchant","66":"smb-order-flow-merchant-directory","67":"smb-order-flow-place-order","68":"smb-order-flow-product-details","69":"smb-order-flow-registration","70":"smb-resubmission-portal","71":"store-review-list-portal","72":"update-failed-email-recipient","73":"update-payment-method","74":"visa-pla-landing-page"}[chunkId]||chunkId) + "." + {"0":"7d8ccf7d","1":"b3187f7b","2":"e1d6fef3","3":"29472ec8","4":"fdf526aa","5":"ff791c27","6":"8f5445e5","7":"2a2c8283","8":"b30c43d0","9":"1f8ccb89","10":"eaaa3cb8","11":"66112fa6","12":"6a4ba03b","13":"1d1fd75f","14":"a0e5c19a","15":"af48ddd4","16":"31d0ff5c","17":"4351b979","18":"85c1287a","19":"7d0ac2cc","20":"e0ede8ff","21":"475d0249","22":"756fa6f0","23":"250093eb","24":"52eae9a8","25":"d59591f6","26":"641fc2fe","27":"1310dfab","28":"710ef7dd","29":"a849f291","30":"743696e1","31":"b7738fae","32":"99c6f6e5","33":"c94c3a34","34":"df7c72f1","35":"3c882fdd","36":"f8217a24","37":"c5f0213c","38":"918e72a8","39":"446eec65","40":"e204cc35","41":"88af2e58","43":"68eb63d9","44":"a24c6781","45":"b0a06600","46":"7d620097","47":"0ee0078e","48":"56230ac4","49":"7a34e8cc","50":"a662aa33","51":"487dc59d","52":"50750039","54":"6b8287ac","55":"f4491181","56":"c666c68d","57":"6c2c7864","58":"814024a8","59":"37819d76","60":"3fdaf14d","61":"01a87439","62":"164e2b11","63":"a93635ad","64":"c0e57d41","65":"ba6b38fe","66":"7db55842","67":"dff65035","68":"eeda4c16","69":"73b88ad8","70":"274a1587","71":"8841ce4c","72":"f452cb54","73":"b9d437b4","74":"35b92d4d","76":"52cfeab6","77":"b9ee5157","78":"45dd6dec","79":"ec369d7a","80":"400366cf","81":"f5537aec","82":"c97ef3cb","83":"2ca5707a","84":"78c57d4e","85":"b99d854b","86":"41859589","87":"d226ea04","88":"d3093ecb"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"29":1,"48":1,"61":1,"80":1,"83":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"20":"affiliate-page","21":"algolia-search","22":"algolia-search-local","23":"card-error","24":"cart-drawer","25":"christmas-holiday-gift-cards-page","26":"consumer-checkout-page","27":"consumer-checkout-page-footer-content","28":"create-a-card-carrier","29":"create-a-card-landing","30":"create-a-card-review","31":"designer-gift-cards","32":"diwali-holiday-gift-cards-page","33":"gift-card-app-page","34":"gift-card-balance-check-page","35":"gift-card-occasions","36":"greeting-card-landing-page","37":"handwritten-page","38":"hanukkah-holiday-gift-cards-page","39":"home-page","40":"kwanzaa-holiday-gift-cards-page","41":"legit-page","43":"mastercard-pla-landing-page","44":"newsletter-signup-page","45":"open-loop-activate-check-balance","46":"open-loop-virtual-exchange","47":"order-details","48":"order-status","49":"pla-landing-page-container","50":"redeem-gift","51":"redeem-gyp-gift","52":"reviews-page","54":"smb-apply","55":"smb-cobrand-cards","56":"smb-order-details","57":"smb-order-details-pdf-invoice","58":"smb-order-flow","59":"smb-order-flow-cancelled","60":"smb-order-flow-confirmation","61":"smb-order-flow-customize-product","62":"smb-order-flow-footer-content","63":"smb-order-flow-landing","64":"smb-order-flow-login","65":"smb-order-flow-merchant","66":"smb-order-flow-merchant-directory","67":"smb-order-flow-place-order","68":"smb-order-flow-product-details","69":"smb-order-flow-registration","70":"smb-resubmission-portal","71":"store-review-list-portal","72":"update-failed-email-recipient","73":"update-payment-method","74":"visa-pla-landing-page"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0","1":"31d6cfe0","2":"31d6cfe0","3":"31d6cfe0","4":"31d6cfe0","5":"31d6cfe0","6":"31d6cfe0","7":"31d6cfe0","8":"31d6cfe0","9":"31d6cfe0","10":"31d6cfe0","11":"31d6cfe0","12":"31d6cfe0","13":"31d6cfe0","14":"31d6cfe0","15":"31d6cfe0","16":"31d6cfe0","17":"31d6cfe0","18":"31d6cfe0","19":"31d6cfe0","20":"31d6cfe0","21":"31d6cfe0","22":"31d6cfe0","23":"31d6cfe0","24":"31d6cfe0","25":"31d6cfe0","26":"31d6cfe0","27":"31d6cfe0","28":"31d6cfe0","29":"7176885d","30":"31d6cfe0","31":"31d6cfe0","32":"31d6cfe0","33":"31d6cfe0","34":"31d6cfe0","35":"31d6cfe0","36":"31d6cfe0","37":"31d6cfe0","38":"31d6cfe0","39":"31d6cfe0","40":"31d6cfe0","41":"31d6cfe0","43":"31d6cfe0","44":"31d6cfe0","45":"31d6cfe0","46":"31d6cfe0","47":"31d6cfe0","48":"21f59128","49":"31d6cfe0","50":"31d6cfe0","51":"31d6cfe0","52":"31d6cfe0","54":"31d6cfe0","55":"31d6cfe0","56":"31d6cfe0","57":"31d6cfe0","58":"31d6cfe0","59":"31d6cfe0","60":"31d6cfe0","61":"c8c378cd","62":"31d6cfe0","63":"31d6cfe0","64":"31d6cfe0","65":"31d6cfe0","66":"31d6cfe0","67":"31d6cfe0","68":"31d6cfe0","69":"31d6cfe0","70":"31d6cfe0","71":"31d6cfe0","72":"31d6cfe0","73":"31d6cfe0","74":"31d6cfe0","76":"31d6cfe0","77":"31d6cfe0","78":"31d6cfe0","79":"31d6cfe0","80":"440db643","81":"31d6cfe0","82":"31d6cfe0","83":"c8c378cd","84":"31d6cfe0","85":"31d6cfe0","86":"31d6cfe0","87":"31d6cfe0","88":"31d6cfe0"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://sitecdn.giftcardgranny.com/19994/react/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonpgift-card-granny-react"] = this["webpackJsonpgift-card-granny-react"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
